import { SetState, GetState } from 'zustand';
import { IExpenseData } from '../types';

export interface IExpensesListSlice {
  expensesData: IExpenseData;
  setExpensesData: (expensesData: IExpenseData) => void;
  getExpensesData: () => IExpenseData;
  resetExpensesListSlice: () => void;
}

const createExpensesListSlice = (set: SetState<IExpensesListSlice>, get: GetState<IExpensesListSlice>) => ({
  expensesData: { taxStatement: [] },
  setExpensesData: (expensesData: IExpenseData) => {
    set({ expensesData });
  },
  getExpensesData: () => get().expensesData,
  resetExpensesListSlice: () => {
    set({ expensesData: { taxStatement: [] } });
  },
});
export default createExpensesListSlice;
